export default (that) => [
  {
    field: 'seq',
    width: 50,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    title: that.$l('table_label_operation') || '操作',
    field: 'col-opt',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_sendSampleNo') || '寄样单号',
    field: 'sendSampleNo',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sendSampleStatus') || '执行状态',
    field: 'sendSampleStatus',
    minWidth: 125,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'sendSampleStatus' },
  },
  {
    title: that.$l('table_label_requestDate') || '安排日期',
    field: 'requestDate',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_deliveryDate') || '发货日期',
    field: 'deliveryDate',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_signDate') || '签收日期',
    field: 'signDate',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_cust') || '客户',
    field: 'custName',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayConsignees') || '收货人',
    field: 'displayConsignees',
    minWidth: 240,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayConsignees' },
  },
  {
    title: that.$l('table_label_deliveryAddress') || '收货地址',
    field: 'deliveryAddress',
    minWidth: 260,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayDelivery') || '快递信息',
    field: 'displayDelivery',
    minWidth: 240,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayDelivery' },
  },
  {
    title: that.$l('table_label_totalQty') || '样品数量',
    field: 'totalQty',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue) || '0',
  },
  {
    title: that.$l('table_label_salesPerson') || '业务人员',
    field: 'salesPersonName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
